import { AgGridReact } from "ag-grid-react";
import { GetRowIdParams } from "ag-grid-community";
import { useCallback } from "react";
import { BundleRow } from "./models/types";
import { useTableData } from "./hooks/useTableData";

interface BundlesTableProps {
	rows: BundleRow[];
	loading: boolean;
}

const styles = {
	borderAgGridTable: {
		border: "1px solid #ccc",
		borderRadius: "4px",
	},
};

export const BundlesTable: React.FC<BundlesTableProps> = ({
	rows,
	loading,
}) => {
	const { columnDefs } = useTableData();

	const getRowId = useCallback(
		(params: GetRowIdParams<BundleRow>) => String(params.data.BundleId),
		[],
	);

	return (
		<div style={{ ...styles.borderAgGridTable, height: 250 }}>
			<AgGridReact<BundleRow>
				rowData={rows}
				columnDefs={columnDefs}
				loading={loading}
				suppressContextMenu
				headerHeight={35}
				rowHeight={35}
				getRowId={getRowId}
			/>
		</div>
	);
};
